module.exports = __webpack_public_path__ + "img/BN.f5dc01df.svg";